import axios from 'axios';
import { DEMO_MODE, DEMO_CONFIRMATION } from 'demo';
import { setLoader, store } from 'redux/index';
import queryString from 'query-string';
import { logoutUser } from 'services';
import { mixpanelTrackError } from 'helpers';
import { decodeToken } from 'helpers';

const v2 = axios.create({
	baseURL: process.env.REACT_APP_V2_BASE_URL,
});

v2.interceptors.request.use(
	(config) => {
		if (
			[
				'/session/authenticate',
				'/session/authenticate/auto',
				'/lifebook/video',
			].includes(
				config.url
			)
		) {
			return config;
		}

		if (config.url[0] === '/') {
			try {
				const query = window.location.search;
				const parsedQuery = query ? queryString.parse(query) : {};
				const queryToken = parsedQuery.token;
				const storageToken = localStorage.getItem('token');
				const cokToken = localStorage.getItem('cok_token');
				const originalToken = localStorage.getItem('originalUser');
				let token = queryToken || storageToken;
				const timeout = localStorage.getItem('timeout');
				const expirationLimit = timeout ? Number(timeout) : 900000;
				const setActiveTime = new Date().getTime() + expirationLimit;
				localStorage.setItem('active', setActiveTime);

				if (!token && config.method === 'get') {
					logoutUser();
				}

				if (!token && !originalToken) {
					logoutUser();
				}

				if (originalToken && config.readOnlyToken) {
					config.headers['Authorization'] = `Bearer ${originalToken}`;
				}

				if (token && !config.readOnlyToken) {
					config.headers['Authorization'] = `Bearer ${token}`;
				}

				if (config?.data?.pass || config.pass) {
					const authPass = config?.data?.pass ? config.data.pass : config.pass;
					config.headers['Authorization-Verify'] = authPass;
					if (DEMO_MODE && authPass === DEMO_CONFIRMATION) {
						config.baseURL = '/demo/api/confirm';
						config.headers['X-Ella-Demo'] = '1';
					}
				}

				if (config.url === '/cok/case') {
					config.headers['X-COK-Authorization'] = `Bearer ${cokToken}`;
				}
			} catch (e) {
				console.log(e);
			}
		}
		if (config.url.includes('s3.') && !config.headers['Content-Type']) {
			config.headers['Content-Type'] = 'image/jpeg';
		}

		return config;
	},

	(error) => {
		return Promise.reject(error);
	}
);

v2.interceptors.response.use(
	(res) => {
		const twoFactorHeader = res.headers['x-enforces-2fa'];
		const storageToken = localStorage.getItem('token');
		const decodedToken = decodeToken(storageToken);
		const agencyEnforces2FA =
			String(twoFactorHeader).toLowerCase() === 'true';
		// only a stored session can be missing 2FA; logged-out pages (e.g. an
		// invite read with the URL token) have nothing to log out of
		if (storageToken && !decodedToken?.enforce2FA && agencyEnforces2FA) {
			store.dispatch(setLoader(false));
			logoutUser();
		}
		return res;
	},
	(err) => {
		const { status, data: { context } = {} } = err?.response || {};
		mixpanelTrackError(
			status,
			err.message,
			err.config?.url,
			err.config?.method,
			context
		);
		if (status === 401) {
			store.dispatch(setLoader(false));
			if (context === 'mfa-required') {
				if (!window?.location.pathname.includes('/confirm2fa')) {
					window.location.href = '/confirm2fa/';
				}
			} else {
				logoutUser();
			}
		}
		throw err;
	}
);

export default v2;
